export default __webpack_public_path__ + "static/media/focus-conditions-icon.c233f4f2.svg";